import { defineAction } from '@cheesecakelabs/boilerplate/utils'

import * as searchService from '_services/search'

export const SEARCH_ITEMS = defineAction('SEARCH_ITEMS')

export const searchItems = queryString => (dispatch, getState) =>
  dispatch({
    type: SEARCH_ITEMS.ACTION,
    payload: searchService.searchItems(getState().user.get('token'))({ queryString }),
  })



// WEBPACK FOOTER //
// ./src/modules/search/actions.js